import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { allocationVlans } from "../../api/endpoints/allocationVlans";
import { qk } from "../../api/queryKeys";
import { adminQueryOptions } from "../../api/adminQueryOptions";

export interface VlanTemplateOptions {
  // Select options over the full vlan_template CATALOG (the FK target switches/
  // ports validate against — NOT the site's generated set). Ordered by `ord`.
  options: { value: number; label: string }[];
  nameByTag: Map<number, string>;
  isPending: boolean;
  error: unknown;
}

export function useVlanTemplateOptions(): VlanTemplateOptions {
  const q = useQuery({
    ...adminQueryOptions,
    queryKey: qk.vlanTemplate(),
    queryFn: () => allocationVlans.vlanTemplate().then((r) => r.data),
  });

  const { options, nameByTag } = useMemo(() => {
    const rows = [...(q.data ?? [])].sort((a, b) => a.ord - b.ord);
    const nameByTag = new Map<number, string>();
    const options = rows.map((r) => {
      nameByTag.set(r.vlan_tag, r.name);
      return { value: r.vlan_tag, label: `${r.vlan_tag} — ${r.name}` };
    });
    return { options, nameByTag };
  }, [q.data]);

  return { options, nameByTag, isPending: q.isPending, error: q.error };
}
